export default __webpack_public_path__ + "static/media/bo_8.038df172.mp3";